module.exports = __webpack_public_path__ + "static/media/student_accommodation_Bristol.3a278111.jpg";